export { AlgoliaFilterMobileFiltersButton } from "./AlgoliaFilterMobileFiltersButton/AlgoliaFilterMobileFiltersButton";
export { AlgoliaRouting } from "./AlgoliaRouting/AlgoliaRouting";
export { CustomCurrentRefinements } from "./CustomCurrentRefinements/CustomCurrentRefinements";
export { CustomRefinementList } from "./CustomRefinementList/CustomRefinementList";
export { CustomSearchBox } from "./CustomSearchBox/CustomSearchBox";
export { NoAlgoliaSearchResults } from "./NoAlgoliaSearchResults/NoAlgoliaSearchResults";
import algoliasearch from "algoliasearch/lite";

import { INDEX_CONTENT } from "../../search/algolia-indexes";

export const getFacets = async (): Promise<unknown> => {
    const algoliaClient = algoliasearch(process.env.GATSBY_ALGOLIA_APP_ID, process.env.GATSBY_ALGOLIA_SEARCH_KEY);
    const index = algoliaClient.initIndex(INDEX_CONTENT);

    let ret = null;
    await index
        .search("", {
            facets: ["*"],
        })
        .then((results) => {
            if (results?.exhaustiveFacetsCount) {
                ret = results?.facets;
            } else {
                throw new Error("Facet inexhaustivity struck.");
            }
        })
        .catch((e) => {
            throw new Error(`Error ${e}`);
        });

    return ret;
};
